import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import Form from './Form';

export default function RefundToWalletDialog({ id, amount, refetch }) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button size="small" sx={{ bgcolor: 'error.light', color: 'error.dark' }} color="error" onClick={handleClickOpen}>
        ثبت تراکنش
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        dir="rtl"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">ایجاد تراکنش</DialogTitle>
        <DialogContent sx={{ p: 1 }}>
          <Form id={id} refetch={refetch} formData={{ amount }} />
        </DialogContent>
      </Dialog>
    </>
  );
}
